import React from 'react';
import { Spinner } from 'react-bootstrap';

interface LoadingOverlayProps {
    isLoading?: boolean;
    children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, children }) => {
    return (
        <div className={`overlay-container ${isLoading ? 'loading' : ''}`}>
            {isLoading && (
                <div className="overlay">
                    <Spinner animation="border" />
                </div>
            )}
            {children}
        </div>
    );
};

export default LoadingOverlay;
